import type { GameInfoType } from '@patrianna/shared-patrianna-types/store/SlotGameFlowModule'
import { intlnumberFormat } from '@patrianna/shared-utils/numbers'
import cx from 'classnames'

import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

type Props = {
  gameBetsAndPrizes: GameInfoType
  activeCurrency: SupportedCurrencies
  isDarkMode?: boolean
  descriptionColor?: string
  title: string
  captionClassName: string
  descriptionClassName: string
}

function TopPrizeContainer({
  gameBetsAndPrizes,
  activeCurrency,
  isDarkMode,
  descriptionColor,
  title,
  captionClassName,
  descriptionClassName,
}: Props) {
  const topPrizeFormattedValue = intlnumberFormat(gameBetsAndPrizes.maxPrize, 'en-US', {
    style: 'decimal',
    minimumFractionDigits: gameBetsAndPrizes.maxPrize % 1 ? 2 : 0,
  })

  return (
    <>
      <span className={cx('mt-typography-caption', classes[captionClassName], isDarkMode && classes.captionDarkMode)}>
        {title}
      </span>
      <span className={cx('mt-typography-caption', classes[descriptionClassName], descriptionColor)}>
        <b>
          {activeCurrency} {topPrizeFormattedValue}
        </b>
      </span>
    </>
  )
}

export default TopPrizeContainer
